module.exports = __webpack_public_path__ + "img/P21-zh.69864c10.png";